import React from "react";
import MainImage from "../../assets/newimages/newimage21.jpg";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";
import PastWork from "../../components/PastWord";
import WebsiteGlowUp from "../../components/WebsiteGlowUp";
import WebsiteGlowUpPro from "../../components/WebsiteGlowUpPro";
import WebsiteDesignAddOns from "../../components/WebsiteDesignAddOns";
import { Helmet } from "react-helmet";

function WebDesign() {
  return (
    <div className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
  <Helmet>
  <title>Custom Web Design with SEO & Strategy for Women Entrepreneurs | Woaom Web Design</title>
  <meta
    name="description"
    content="Woaom Web Design creates custom websites powered by React, Tailwind CSS, and Firebase for women entrepreneurs. High-converting, mobile-first designs built to grow your brand in cities like Dallas, Houston, Austin, and Atlanta."
  />
  <meta
    name="keywords"
    content="custom web design for women entrepreneurs Dallas TX, Houston TX custom website design with SEO, Austin women-owned business websites, Atlanta GA web design with strategy, New York City female founder websites, Washington DC women-led website design, Philadelphia PA custom websites for women entrepreneurs, Memphis TN strategic web design, Baton Rouge LA web design services for women founders, Shreveport LA women-led business websites, New Orleans custom website studio, Macon GA web design for female founders, Augusta GA custom web design packages, Baltimore women entrepreneurs web design, React developer for hire Dallas, Tailwind CSS website design Houston, Firebase hosting setup Austin TX, Flodesk integration for websites Atlanta GA, mobile responsive websites for women entrepreneurs, UX/UI design for women-led businesses, feminine web design agency New York City, strategic website builds for women founders Washington DC, modern brand-first websites Philadelphia PA, conversion-focused web design Memphis TN, scalable web systems Baton Rouge LA, high-converting business websites Shreveport LA, intentional web design for women New Orleans, startup website packages Macon GA, premium web design for women entrepreneurs Augusta GA, clean code websites Baltimore"
  />
</Helmet>


      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-top"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <NavLite />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-white italic text-3xl max-w-96 font-semibold backdrop-blur-sm">Website Glow-Up Packages</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                Websites That Glow With Purpose
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                Whether you're launching your brand or leveling up, our custom sites are designed to convert — with strategy, soul, and standout design.
              </p>
            </div>

            {/* New Package Layout */}
             <WebsiteGlowUp/>
             <WebsiteGlowUpPro/>
             <WebsiteDesignAddOns/>
            

            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                START A PROJECT →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Don’t worry if you're not sure what you need — we’ll guide you every step.
              </p>
            </div>
          </div>
        </section>
        <PastWork />
        <Footer />
      </section>
    </div>
  );
}

export default WebDesign;
